export default function ReviewsBanner() {
  return (
    <section className="relative h-[400px] overflow-hidden">
      <img
        src="https://static.readdy.ai/image/0a3008c36638439fa5d134c9c6a19be7/5cc29a119e602915ab53f760f20bd876.jpeg"
        alt="Beaulieu Dental Chelmsford - Professional dental treatment"
        title="Beaulieu Dental - Advanced dental care with gentle approach"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#444c42]/90 via-[#444c42]/70 to-[#444c42]/90"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-4">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Advanced Dental Care with a Gentle Touch
          </h2>
          <p className="text-xl text-white/90 max-w-2xl mx-auto leading-relaxed">
            Experience modern dentistry delivered with compassion and expertise in our state-of-the-art Chelmsford practice
          </p>
        </div>
      </div>
    </section>
  );
}
